export type LanguageInterface = {
    languageID: number,
    languageCode: string
};

export const CHANGE_LANGUAGE:string = 'CHANGE_LANGUAGE';


export type CHANGE_LANGUAGE_ACTION_TYPE = {
    type: string,
    newLanguage: LanguageInterface
};

export const CHANGE_LANGUAGE_ACTION = (newLanguage: LanguageInterface): CHANGE_LANGUAGE_ACTION_TYPE => {
    return {
        type: CHANGE_LANGUAGE,
        newLanguage: newLanguage
    };
};


export type LOCALIZATION_STATE_TYPE = {
    activeLanguage: LanguageInterface | null
};



